import { render, staticRenderFns } from "./campaign-updates.vue?vue&type=template&id=94d6c76e&scoped=true&"
import script from "./campaign-updates.vue?vue&type=script&lang=js&"
export * from "./campaign-updates.vue?vue&type=script&lang=js&"
import style0 from "./campaign-updates.vue?vue&type=style&index=0&id=94d6c76e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94d6c76e",
  null
  
)

export default component.exports